// JSON chuẩn hoá theo RFC 8785 (JCS) cho các giá trị Blueprint dùng: object · array · string · boolean · null · số nguyên an
// toàn. Khoá sắp theo code unit UTF-16 (đúng mục 3.2.3). Số thực không xuất hiện trong spec / diff / manifest (tiền là chuỗi
// minor unit — K5) ⇒ gặp số không nguyên là lỗi, không đoán cách in.

export function canonicalJson(value: unknown): string {
  if (value === null || typeof value === "boolean" || typeof value === "string") return JSON.stringify(value);
  if (typeof value === "number") {
    if (!Number.isSafeInteger(value)) throw new TypeError(`canonicalJson: chỉ nhận số nguyên an toàn (${value})`);
    return String(value);
  }
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(",")}]`;
  if (typeof value === "object") {
    const entries = Object.entries(value as Record<string, unknown>).filter(([, v]) => v !== undefined);
    entries.sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${canonicalJson(v)}`).join(",")}}`;
  }
  throw new TypeError(`canonicalJson: kiểu không hỗ trợ (${typeof value})`);
}
